import { render } from "./TuiKuanDetail.vue?vue&type=template&id=231bfc84"
import script from "./TuiKuanDetail.vue?vue&type=script&lang=js"
export * from "./TuiKuanDetail.vue?vue&type=script&lang=js"

import "./TuiKuanDetail.vue?vue&type=style&index=0&id=231bfc84&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__